import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { TnWithDestinationDC } from "src/app/console-core/modules/boss-api/generated/models";
import { SDApiVersionControlService } from 'src/app/services/sdapi-version-control';
@Injectable({
  providedIn: 'root'
})
export class PhoneInventoryService {

  tnsService;
  callFlowsService;
  locationService;
  usersService;

  constructor(private sdapiVersion: SDApiVersionControlService) {
    this.tnsService = this.sdapiVersion.tnsService;
    this.callFlowsService = this.sdapiVersion.callFlowsService;
    this.locationService = this.sdapiVersion.locationSevice;
    this.usersService = this.sdapiVersion.usersService;
  }

  getInventory(): Observable<Array<TnWithDestinationDC>> {
    return this.tnsService.TnsGetTnsWithDestination(null);
  }

  getPhoneDetails(parms) {
    return this.tnsService.TnsGetTnWithDestination(parms);
  }

  getDestinationTypes() {
    return this.tnsService.TnsTnDestinationTypes(null);
  }

  getCallflowDestinationNames() {
    const params = { Authorization: null };
    return this.callFlowsService.CallFlowsGetCallFlowsByAccount(params);
  }

  getUsersDestinationNames() {
    const params = { Authorization: null };
    return this.usersService.UsersGetUsersByAccount(params);
  }

  getBridgedDestinationNames() {
    return this.usersService.UsersGetShallowBCAProfiles();
  }

  updatePhoneConfiguration(data) {
    const param = { request: data, Authorization: null };
    return this.tnsService.TnsAssignPhoneNumber(param);
  }

  getLocationDetails(locationUuid: string) {
    let locationParams = { locationUuid: locationUuid, Authorization: null };
    return this.locationService.LocationsGetLocation(locationParams);
  }
}


